module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('div', {
    staticClass: "title pt-5"
  }, [_c('span', {
    staticClass: "fw-400"
  }, [_vm._v(_vm._s(_vm.id ? 'Editar' : 'Nueva') + " clase")])]), _c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "box-lista",
    staticClass: "box lista-solicitud-vacaciones contenedor-interno"
  }, [_c('div', {
    staticClass: "display-flex mb-5"
  }, [_c('div', {
    staticClass: "volver display-flex flex-1"
  }, [_c('button', {
    staticClass: "button is-small",
    on: {
      "click": function($event) {
        return _vm.volver()
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  })]), _c('span', [_vm._v("Volver")])])]), _c('button', {
    staticClass: "button is-small is-primary",
    attrs: {
      "disabled": _vm.isLoadingClase
    },
    on: {
      "click": function($event) {
        return _vm.guardarClase()
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  })]), _c('span', [_vm._v("Guardar")])])]), _c('div', {
    staticClass: "body pt-10"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "display-flex"
  }, [_c('div', {
    staticClass: "control margin-bottom-10 flex-1"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Orden")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orden),
      expression: "orden"
    }],
    staticClass: "input w-90",
    attrs: {
      "type": "number",
      "disabled": _vm.isLoadingClase
    },
    domProps: {
      "value": (_vm.orden)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.orden = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "control margin-bottom-10 text-center"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Activo")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activo),
      expression: "activo"
    }],
    staticClass: "checkbox",
    attrs: {
      "type": "checkbox",
      "disabled": _vm.isLoadingClase
    },
    domProps: {
      "checked": Array.isArray(_vm.activo) ? _vm._i(_vm.activo, null) > -1 : (_vm.activo)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.activo,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.activo = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.activo = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.activo = $$c
        }
      }
    }
  })])]), _c('div', {
    staticClass: "control margin-bottom-10 flex-1"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Título")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.titulo),
      expression: "titulo"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoadingClase
    },
    domProps: {
      "value": (_vm.titulo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.titulo = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "control margin-bottom-10"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Descripción")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.descripcion),
      expression: "descripcion"
    }],
    staticClass: "textarea w-300",
    staticStyle: {
      "field-sizing": "content !important"
    },
    attrs: {
      "disabled": _vm.isLoadingClase
    },
    domProps: {
      "value": (_vm.descripcion)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.descripcion = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "control margin-bottom-10 flex-1"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Youtube link")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.linkYT),
      expression: "linkYT"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoadingClase
    },
    domProps: {
      "value": (_vm.linkYT)
    },
    on: {
      "focus": function (e) { return e.target.select(); },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.linkYT = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "control margin-bottom-10 flex-1"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Duración")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.duracion),
      expression: "duracion"
    }],
    staticClass: "input w-100",
    attrs: {
      "type": "time",
      "step": "1",
      "disabled": _vm.isLoadingClase
    },
    domProps: {
      "value": (_vm.duracion)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.duracion = $event.target.value
      }
    }
  })])])]), _c('div', {
    staticClass: "display-flex fdr space-evenly flex-wrap pt-10"
  }, [_c('div', {
    staticClass: "caja lista-solicitud-vacaciones contenedor-interno"
  }, [_c('materiales-curso-lista', {
    ref: "materialesRef",
    attrs: {
      "type": "clase"
    },
    on: {
      "save": function($event) {
        return _vm.saveMaterial()
      }
    }
  })], 1), _c('div', {
    staticClass: "caja lista-solicitud-vacaciones contenedor-interno"
  }, [_c('evaluaciones-curso-lista', {
    ref: "evaluacionesRef",
    attrs: {
      "type": "clase"
    },
    on: {
      "save": function($event) {
        return _vm.saveEvaluacion()
      }
    }
  })], 1)])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a795bc74","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/View_Gestion_Clases_Editar.vue
// module id = 938
// module chunks = 0